import Button from '@berlitz/button'
import { H2 } from '@berlitz/globals'
import styled, { css } from 'styled-components'

export const Tab = styled.div`
  cursor: pointer;
  padding: 0 ${({ theme }) => theme.space.xxs};
`

export const TabLabel = styled.div<{ withInfoIcon?: boolean }>`
  ${({ withInfoIcon }) =>
    withInfoIcon
      ? `
    display: flex;
    align-items: center;

    svg {
      font-size: 20px;
      margin-left: 6px;
    }
  `
      : ``}
`

const BaseFixedCSS = css`
  background-color: ${({ theme }) => theme.palette.powder};
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.1);
  z-index: 100;
`

export const FixedButton = styled.div<{ show?: boolean }>`
  position: absolute;
  right: 0;
  padding: 10px;
  cursor: pointer;

  ${({ theme, show }) => css`
    display: ${show ? 'flex' : 'none'};
    color: ${theme.colors.brandPrimary};
    top: ${theme.layout.xl};
    ${BaseFixedCSS}
    svg {
      font-size: ${theme.fontSize.xl};
    }
  `}
`

export const MMIFixed = styled.div<{ show?: boolean }>`
  ${({ show, theme }) =>
    show
      ? css`
          display: flex;
          flex-flow: column;
          position: absolute;
          right: 0;
          top: ${theme.layout.xl};
          width: 97%;
          ${BaseFixedCSS}
        `
      : css`
          display: none;
        `}
`

export const StyledH2 = styled(H2)`
  margin-bottom: 0;
`

export const CloseBtn = styled.div`
  margin-left: auto;
  cursor: pointer;
  svg {
    font-size: ${({ theme }) => theme.fontSize.xs};
  }
`

export const MMIHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  ${({ theme }) => css`
    padding: ${theme.space.sm + ' ' + theme.space.md};
    border-bottom: 1px solid ${theme.palette.gray50};
  `}
`

export const MMIContent = styled.div`
  display: flex;
  flex-flow: column;
  ${({ theme }) => css`
    padding: 0 ${theme.space.sm};
  `}
`

export const MMISubContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(95px, 1fr));
  row-gap: ${({ theme }) => theme.fontSize.sm};
  overflow: auto;
  max-height: 205px;
`

export const MMIButton = styled(Button)`
  display: flex;
  max-width: fit-content;
  align-self: center;
  justify-content: center;
  align-items: center;
  width: 75px;
  height: 34px;
`

export const BlockedIconWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const BlockedIcons = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  height: max-content;
`

export const SearchIcon = styled.div`
  ${({ theme }) => `
    background-color: white;
    width: 38px;
    height: 18px;
    border-radius: 9px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    padding: 3px 20.6px 3px 4px;

    svg {
      color: ${theme.palette.red100};
      font-size: 12px;
    }
`}
`

export const BlockIcon = styled.div`
  font-size: 23px;
  border-radius: 100%;
  background-color: white;
  width: 23px;
  height: 23px;
  margin-left: -18px;

  svg {
    font-size: 23px;
  }
`

export const PrefDesc = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.bold};
    letter-spacing: 0.56px;
  `}
`

export const SPSwitch = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.64;
  letter-spacing: 0.49px;

  ${({ theme }) => `
    display: flex;
    gap: ${theme.space.sm};
    font-size: ${theme.fontSize.xxs};
    font-weight: ${theme.fontWeight.regular};
  `}
`

export const SPWrapper = styled.div<{ updating?: boolean }>`
  label {
    ${({ theme, updating }) => `
      padding: ${theme.space.xs} ${theme.space.md};
      ${
        updating
          ? `
        opacity: 0.5;
        cursor: wait;
      `
          : ''
      }
    `}
  }

  [role='radiogroup'] {
    margin: 0;
  }

  ${({ updating }) =>
    updating
      ? `
    cursor: wait;
    span {
      cursor: wait;
    }
  `
      : ''}
`
